export default __webpack_public_path__ + "static/media/Arc'Ion LinuxDistro4U.a8298dd9.png";